export enum DeadlineType {
    Unkown = 0,
    Overdue = 1,
    Tomorrow = 2,
    In3Days = 3,
    In5Days = 4,
    In10Days = 5,
    MoreThanAMonth = 6,
}

export enum DeadlineTypeNotificationFlags {
    OneDayBefore = 0x000001,
    ThreeDaysBefore = 0x000002,
    FiveDaysBefore = 0x000004,
    TenDaysBefore = 0x000008,
}

export const deadlineTypes: Record<string, { value: number; label: string }> = {
    Unknown: {
        value: DeadlineType.Unkown,
        label: "Nepoznato",
    },
    Overdue: {
        value: DeadlineType.Overdue,
        label: "Istekao",
    },
    Tomorrow: {
        value: DeadlineType.Tomorrow,
        label: "Sutra",
    },
    In3Days: {
        value: DeadlineType.In3Days,
        label: "Za 3 dana",
    },
    In5Days: {
        value: DeadlineType.In5Days,
        label: "Za 5 dana",
    },
    In10Days: {
        value: DeadlineType.In10Days,
        label: "Za 10 dana",
    },
    MoreThanAMonth: {
        value: DeadlineType.MoreThanAMonth,
        label: "Više od mjesec dana",
    },
};

export const deadlineNotificationTypes: Record<string, { value: number; label: string }> = {
    OneDayBefore: {
        value: DeadlineTypeNotificationFlags.OneDayBefore,
        label: "1 dan prije",
    },
    ThreeDaysBefore: {
        value: DeadlineTypeNotificationFlags.ThreeDaysBefore,
        label: "3 dana prije",
    },
    FiveDaysBefore: {
        value: DeadlineTypeNotificationFlags.FiveDaysBefore,
        label: "5 dana prije",
    },
    TenDaysBefore: {
        value: DeadlineTypeNotificationFlags.TenDaysBefore,
        label: "10 dana prije",
    },
};
